import type { AppManifest } from '@/apps/types';
import { lazy } from 'react';

/**
 * SkiFall.
 *
 * After Chris Pirih's SkiFree, 1991. The hill, the trees, the
 * jumps and the monster past the 2000 metre line are all his; the skiing is
 * not, and neither are the coins, the gates or the pop jump. See "The
 * hill" in the README for what changed and why.
 *
 * It keeps his filename, though. `ski32.exe` is what the original shipped as.
 *
 * Unlike Minesweeper this one is resizable, and the window size is the size
 * of the hill you can see — a wider window is a genuinely easier run, which is
 * exactly how it worked when the original was dragged wider. `minSize` is the
 * point below which the skier can no longer see far enough down the hill to
 * react to what is on it.
 *
 * Takes no args.
 */
export const skifallApp: AppManifest = {
  id: 'skifall',
  name: 'SkiFall',
  icon: '/assets/icons/skifall.svg',
  component: lazy(() => import('./SkiFall')),

  defaultSize: { w: 640, h: 480 },
  minSize: { w: 320, h: 260 },

  group: 'Games',
  titleFor: () => 'SkiFall',
};
